import React from 'react';
import styled from '@emotion/styled';
import { ChevronButtonWithText } from '../ChevronButtonWithText/ChevronButtonWithText';
import { EmotionBreakpoint } from 'dw-us-ui';

const BackToTopContainer = styled.div`
  margin: 1.5rem auto;
  .d-flex {
    display: flex;
  }
  .ruler {
    flex-basis: 80%;
  }
  .top-icon {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-basis: 21%;
  }
  ${EmotionBreakpoint('desktop')} {
    max-width: 970px;
  }
  ${EmotionBreakpoint('tablet')} {
    max-width: 720px;
  }
  @media (min-width: 576px) and (max-width: 768px) {
    max-width: 540px;
    .ruler {
      flex-basis: 75%;
    }
    .top-icon {
      flex-basis: 26%;
    }
  }
  @media (max-width: 575px) {
    max-width: 540px;
    .ruler {
      flex-basis: 70%;
    }
    .top-icon {
      flex-basis: 30%;
    }
  }
`;

const BackToTop = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <BackToTopContainer data-testid="back-to-top" className="back-to-top">
      <div className="h-100 d-flex">
        <div className="flex-grow-1 pr-4 ruler">
          <hr className="w-100" />
        </div>
        <div className="top-icon">
          <ChevronButtonWithText chevronDirection="up" text="Back to Top" onClick={scrollToTop} />
        </div>
      </div>
    </BackToTopContainer>
  );
};

export { BackToTop };
